import { MessageCircle } from "lucide-react"
import { lazy, Suspense, useState } from "react"

import { useAuth } from "../../hooks/use-auth"
import { Button } from "../ui/button"

const Panel = lazy(async () => {
  const module = await import("./global-chat-panel")
  return { default: module.GlobalChatPanel }
})

export function GlobalChat() {
  const { user } = useAuth()
  return user ? <ChatLauncher key={user.id} userId={user.id} /> : null
}

function ChatLauncher({ userId }: { userId: number }) {
  const [isOpen, setOpen] = useState(false)
  return (
    <>
      <Button
        variant="primary"
        aria-label="Open Nova chat"
        aria-expanded={isOpen}
        className="fixed bottom-5 right-5 z-40 h-12 gap-2 px-5 shadow-floating motion-reduce:transition-none"
        onClick={() => setOpen(true)}
      >
        <MessageCircle aria-hidden className="size-5" />
        Nova
      </Button>

      {isOpen && (
        <Suspense
          fallback={
            <p
              role="status"
              className="fixed bottom-20 right-5 z-40 rounded-xl bg-card p-4 text-sm shadow-floating"
            >
              Opening Nova…
            </p>
          }
        >
          <Panel userId={userId} onClose={() => setOpen(false)} />
        </Suspense>
      )}
    </>
  )
}
